import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchEventSenders, createSender } from '../../../actions/admin/models/events';
import { MODELS } from '../../../constants/admin/settings';
import { TABLE_INDICES } from '../../../constants/admin/tables';
import AdminTable from '../AdminTable';
import AdminModalForm from '../AdminModalForm';
import EventSenderInputs from '../../../components/admin/forms/events/EventSenderInputs';
import { openModalFormWithData } from '../../../actions/admin/modal.forms';

class EventEmailSenders extends Component {
    _fetchSenders = () => {
        this.props.fetchEventSenders(this.props.eventId);
    };
    _openSendersModal = () => {
        this.props.openModalFormWithData(MODELS.EVENT_EMAIL_SENDER, { name: '', email: '' });
    };
    _transformRows = {
        verified: ver => {
            return ver ? 'Yes' : 'No';
        }
    };
    _createSender = data => {
        this.props.createSender(this.props.eventId, data);
    };
    render() {
        return (
            <React.Fragment>
                <AdminModalForm
                    title="Add email sender"
                    fields={EventSenderInputs}
                    model={MODELS.EVENT_EMAIL_SENDER}
                    createAction={this._createSender}
                    createLabel="Add sender"
                />
                <AdminTable
                    forceNoSelect={true}
                    canOpenRows={false}
                    buttonAction={this._openSendersModal}
                    transformFunctions={this._transformRows}
                    tableIndex={TABLE_INDICES[MODELS.EVENT_EMAIL_SENDER]}
                    fetchDataFunction={this._fetchSenders}
                    model={MODELS.EVENT_EMAIL_SENDER}
                />
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch =>
    bindActionCreators({ fetchEventSenders, createSender, openModalFormWithData }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(EventEmailSenders);
